
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAdminThunk, setDeployThunk } from "../store/vodStore";


export default function Wrapper({ children }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.split("/");
  
    useEffect(() => {
      //console.log(location.pathname," / ", path.length);
      //console.log(path[1]," / ",path[2]," / ",path[3]," / ",path[4]," / ",path[5]," / ",path[6]);
      if (path[1] === "admin") { //관리자 화면 - 영상 url      
        dispatch(setAdminThunk("Y"));
      } 
      if( path[2] === "check"){ //관리자 화면 - 영상 배포
        dispatch(setDeployThunk("Y"));
      } 
      if(path[1] === "QR"){ //사용자 화면 - 영상 url (QR 서비스)  
        dispatch(setAdminThunk("N")); 
        dispatch(setDeployThunk("N"));
      }
      if(path[1] === "JApp"){ //재능이랑 화면 
        dispatch(setAdminThunk("J")); 
      }
    }, []);
  
  return (
    <>
    {children}
    </>
  );
}
